import Chat from './Chat';

export default Chat;


// WEBPACK FOOTER //
// ./src/pages/chat/index.js